import { Component, OnInit } from '@angular/core';
import { AuthUseCase } from 'src/app/core/usecases/auth/AuthUseCase';
import { AuthModel } from '../../core/model/AuthModel';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-authentication',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {
  loading = false;

  constructor(
    private authUseCase: AuthUseCase,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.getAuth();
  }

  getAuth(): void {
    this.loading = true;
    const auth: AuthModel = {
      username: environment.username_auth,
      password: environment.password_auth
    };

    this.authUseCase.execute(auth).subscribe(
      data => {
        this.loading = false;
        console.log(data);
        this.router.navigate(['/cotizacion']);
      },
      error => {
        console.log(error);
        this.loading = false;
    });
  }

}
